module.exports = __webpack_public_path__ + "assets/media/day28.7fc665e4.mp3";